import { Amount } from 'src_common/common/amount/Amount';
import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

/**
 * validator for a amount as a string
 */
export const validateAmountRequire = (value: string): Result<Amount> => {
    if (value.trim() === '') {
        return Result.createError('This field is required.');
    }
    try {
        return Result.createOk(new Amount(value));
    } catch (e) {
        return Result.createError('Incorrect number.');
    }
};

/**
 * validator for a amount or empty string
 */
export const validateAmountOrNothing = (value: string): Result<Amount | string> => {
    if (value.trim() === '') {
        return Result.createOk('');
    }
    try {
        return Result.createOk(new Amount(value));
    } catch (e) {
        return Result.createError('Incorrect number.');
    }
};

/**
 * validator for positive number
 */
export const validatePositive = (amount: Amount): Result<Amount> => {
    const regex = /^(0|[1-9]\d*\.?\d{0,2})$/;
    const isInvalid = !regex.test(amount.value);
    if (isInvalid) {
        return Result.createError('Incorrect number.');
    }
    return Result.createOk(new Amount(amount.value));
};

/**
 * validator for positive number or nothing (empty string)
 */
export const validatePositiveOrNothing = (amount: Amount | string): Result<Amount | string> => {
    if (typeof amount === 'string' && amount.trim() === '') {
        return Result.createOk('');
    } else if (typeof amount !== 'string') {
        const regex = /^(0|[1-9]\d*\.?\d{0,2})$/;
        const isInvalid = !regex.test(amount.value);
        if (isInvalid) {
            return Result.createError('Incorrect number.');
        }
        return Result.createOk(new Amount(amount.value));
    }
    return Result.createError('Incorrect value.');
};

export const validateAmountPattern =
    () =>
    (amount: Amount): Result<Amount> => {
        const regex = /^\d+(\.\d{1,2})?$/;

        const hasPricePattern = regex.test(amount.value);
        if (!hasPricePattern) {
            return Result.createError('Incorrect number.');
        }
        return Result.createOk(amount);
    };
